export const isInternetExplorer = /MSIE|Trident/.test(window.navigator.userAgent);
